/**
 * React Hook for Sync Status
 * 
 * Provides real-time sync status updates from DatabaseService
 * 
 * Usage:
 * ```javascript
 * const { status, lastSyncTime, error } = useSync();
 * 
 * // status: 'syncing' | 'synced' | 'error' | 'offline'
 * // lastSyncTime: Date | null
 * // error: Error | null
 * ```
 */

import { useState, useEffect } from 'react';
import databaseService from '../services/database.service';

export function useSync() {
  const [syncState, setSyncState] = useState({
    status: 'offline',
    lastSyncTime: null,
    error: null
  });

  useEffect(() => {
    // Subscribe to sync status changes
    const unsubscribe = databaseService.onSyncStatusChange((statusUpdate) => {
      setSyncState({
        status: statusUpdate.status,
        lastSyncTime: statusUpdate.lastSyncTime,
        error: statusUpdate.error
      });
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);

  return syncState;
}

export default useSync;
